import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useAuth } from '../context/AuthContext';

// The top bar in elebyte.io's idiom, matching Support, Education, Control and Auth: the cursive
// wordmark with a "Partners" tag, the destinations as italic words that take a skewed cyan
// underline, and the way out. styles live in src/index.css (.pt-bar / .pt-navlink).
const NAV_TABS = [
  { label: 'Dashboard', path: '/' },
  { label: 'Activity', path: '/activity' },
  { label: 'Settings', path: '/settings' },
];

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => (path === '/' ? location.pathname === '/' : location.pathname.startsWith(path));

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box component="header" className="pt-bar">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px', minWidth: 0 }}>
          <a className="pt-logo" href="https://elebyte.io" aria-label="Elebyte">
            <span className="pt-logo__mark">
              <img src="/cursive-logo.svg" alt="" />
              <span className="pt-logo__sheen" aria-hidden="true" />
            </span>
          </a>
          <span className="pt-bar__tag">Partners</span>
        </Box>

        <Box component="nav" className="pt-nav" aria-label="Main">
          {NAV_TABS.map((tab) => (
            <RouterLink
              key={tab.path}
              to={tab.path}
              className={`pt-navlink${isActive(tab.path) ? ' is-active' : ''}`}
              aria-current={isActive(tab.path) ? 'page' : undefined}
            >
              {tab.label}
            </RouterLink>
          ))}
        </Box>

        <Box className="pt-bar__who">
          <span className="pt-bar__email">{user?.email}</span>
          <Button variant="outlined" size="small" onClick={logout}>Sign Out</Button>
        </Box>
      </Box>

      {children}
    </Box>
  );
}
